var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-content-template" }, [
    _c("div", { staticClass: "c-content-template__container" }, [
      _c("div", { staticClass: "c-content-template__content" }, [
        _c(
          "div",
          { staticClass: "c-content-template__row" },
          _vm._l(_vm.config.content, function(content) {
            return _c(
              "div",
              { key: content.index, staticClass: "c-content-template__cell" },
              [
                content.title
                  ? _c("h4", { staticClass: "c-content-template__title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(content.title) +
                          "\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                content.description
                  ? _c("div", {
                      staticClass: "c-rte c-content-template__description",
                      domProps: { innerHTML: _vm._s(content.description) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                content.link
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "c-button c-button--brand c-button--bg-color-brand-seven c-content-template__action",
                        attrs: { href: content.link.url }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(content.link.text) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "c-content-template__row" }, [
          _vm.config.footerContent
            ? _c("div", {
                staticClass: "c-rte c-content-template__description",
                domProps: { innerHTML: _vm._s(_vm.config.footerContent) }
              })
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79ede62f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79ede62f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/contact-us/_vue/ContentTemplate.vue
// module id = 776
// module chunks = 0